import { DocumentEditMode } from 'models/userSetting';
import { CopilotConversationDTO } from './copilotConversationDTO';

export class CopilotGenericContentDTO {
  sessionId?: number;

  contextKey?: string;

  entityType?: number;

  entityId?: number;

  conversation: CopilotConversationDTO;

  selectedDocument?: CopilotSelectedDocumentDTO;

  // Reference to the tenant-authored library instruction that should run. The backend resolves the
  // instruction from the database and runs its text; the client never sends the instruction itself.
  instructionExternalId?: string;

  // The entity field the user is editing while asking, with its current text. Mirrors the backend
  // CopilotActiveFieldDTO; set for a field-scoped prompt only.
  activeField?: CopilotActiveFieldDTO;

  // The general knowledge skill the Prompt binding names (review-record, create-task, ...). Mirrors the
  // backend CopilotGenericDTO.Skill; an unknown name is logged there and the turn runs without a skill.
  skill?: string;

  // The setId of the question card this turn answers. Mirrors the backend CopilotGenericDTO.AnsweredQuestionSetId;
  // a typed message sends none, and the server takes it as the answer in words of the card the session waits on.
  answeredQuestionSetId?: string;

  // The CopilotScene member name of a list scene or the dashboard ('Risks', 'MyTasks', 'Dashboard'). Mirrors
  // the backend CopilotGenericDTO.Scene; a detail scene sends its entity and a usage scene its context key.
  scene?: string;

  // The title of the session this turn creates, when a field action starts it. Mirrors the backend
  // CopilotGenericDTO.SessionTitle; ignored on a turn that names a session or carries no active field.
  sessionTitle?: string;

  // The process the conversation is about after a process handed back (the KPI report, PLAN-070). Mirrors the
  // backend CopilotGenericDTO.ActiveProcess; the server carries it over to the next turns.
  activeProcess?: CopilotActiveProcessDTO;

  constructor() {
    this.conversation = new CopilotConversationDTO();
  }
}

// Mirror of the backend CopilotActiveProcessDTO: processId the TenantProcess (AIProcessType) value
export class CopilotActiveProcessDTO {
  processId: number;

  key?: string;

  entityId?: number;

  constructor() {
    this.processId = 0;
  }
}

export class CopilotActiveFieldDTO {
  // the lowercase DTO property the editor binds ('description', 'analysis', 'strategy')
  field: string;

  // the editor's current text, saved or not: an HTML fragment for rich-text fields, may be empty
  text: string;

  constructor() {
    this.field = '';
    this.text = '';
  }
}

export class CopilotSelectedDocumentDTO {
  contentBlockId?: string;

  version?: number;

  title?: string;

  isDocumentEditorSession?: boolean;

  documentEditMode?: DocumentEditMode;

  // The user's current text selection in the document (text plus best-effort start/end blockId+offset
  // anchors). Undefined when nothing is selected. Mirrors the backend CopilotSelectedDocumentDTO.
  selectionText?: string;

  selectionStartBlockId?: string;

  selectionStartOffset?: number;

  selectionEndBlockId?: string;

  selectionEndOffset?: number;
}
